var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2.95002C6.10577 2.95002 2.9488 6.10699 2.9488 10.0013C2.9488 13.8956 6.10577 17.0526 10.0001 17.0526C13.8944 17.0526 17.0514 13.8956 17.0514 10.0013C17.0514 6.10699 13.8944 2.95002 10.0001 2.95002ZM1.66675 10.0013C1.66675 5.39893 5.39771 1.66797 10.0001 1.66797C14.6025 1.66797 18.3334 5.39893 18.3334 10.0013C18.3334 14.6037 14.6025 18.3346 10.0001 18.3346C5.39771 18.3346 1.66675 14.6037 1.66675 10.0013ZM9.35906 6.5825C9.35906 6.22847 9.64605 5.94147 10.0001 5.94147H10.0086C10.3627 5.94147 10.6497 6.22847 10.6497 6.5825C10.6497 6.93653 10.3627 7.22352 10.0086 7.22352H10.0001C9.64605 7.22352 9.35906 6.93653 9.35906 6.5825ZM8.50436 10.0013C8.50436 9.64727 8.79135 9.36028 9.14538 9.36028H10.0001C10.3541 9.36028 10.6411 9.64727 10.6411 10.0013V12.7791H10.8548C11.2088 12.7791 11.4958 13.0661 11.4958 13.4201C11.4958 13.7741 11.2088 14.0611 10.8548 14.0611H10.0001C9.64605 14.0611 9.35906 13.7741 9.35906 13.4201V10.6423H9.14538C8.79135 10.6423 8.50436 10.3553 8.50436 10.0013Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBlack);
export default __webpack_public_path__ + "static/media/info-icon-black.447cfb51f9f0aeda97c2163c69bd4dec.svg";
export { ForwardRef as ReactComponent };